import * as React from "react";
import Translate from "../../common/functions/translate";
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import ProductAddEditDialog from './productAddEditDialog';
import { ProductModel } from "../../models/product/productModel";
import ProductService from "../../services/productService";
import { ProductFilterSettingsModel } from "../../models/product/productFilterSettingsModel";
import ProductList from './productList';
import CategoryService from "../../services/categoriesService";
import ProductFilter from './productFilter';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import Button from "@material-ui/core/Button";
import CategoryTreeFilter from './categoryTreeFilter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ActiveFilterType } from "../../common/enums";

interface IProps {
}

interface IState {
    isLoading: boolean,
    isVisibleDialog: boolean;
    isVisibleDialogWrap: boolean;
    from: number;
    numberOfRows: number;
    products: Array<ProductModel>;
    currentProduct: ProductModel;
    productsSettings: ProductFilterSettingsModel;
    totalRecordsCount: number;
    isVisibleConfirmDialog: boolean;
    selectedCategoryId: number,
    currentCategoryLabel: string
}

const initFrom = 0;
const numberOfRows = 10;

class ProductsContainer extends React.Component<IProps, IState> {
    snackbar: any;
    productsService = new ProductService();
    categoryService = new CategoryService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            isVisibleDialog: false,
            isVisibleDialogWrap: false,
            from: initFrom,
            numberOfRows: numberOfRows,
            products: new Array<ProductModel>(),
            currentProduct: new ProductModel(),
            productsSettings: new ProductFilterSettingsModel(),
            totalRecordsCount: 0,
            isVisibleConfirmDialog: false,
            selectedCategoryId: 0,
            currentCategoryLabel: ''
        };
    }

    componentDidMount() {
        const settings = { ...this.state.productsSettings };
        settings.actives = ActiveFilterType.Actives;
        this.setState({ productsSettings: settings }, () => this.getAllProducts(this.state.from, this.state.numberOfRows));
    }

    getAllProducts(from: number, numberOfRows: number) {
        this.setState({
            isLoading: true
        });

        this.productsService.getAllProducts(from, numberOfRows, this.state.productsSettings).then(
            (data: any) => {
                this.setState({
                    isLoading: false,
                    from: from,
                    products: data.products,
                    totalRecordsCount: data.totalRecordsCount
                });
            })
            .catch(error => {
                console.log('err')
                this.setState({
                    isLoading: false
                });
                this.snackbar.show({ severity: 'error', summary: error.message });
            });
    }

    showAddEditDialog = (show: boolean) => {
        this.setState({
            isVisibleDialogWrap: show,
        });
        setTimeout(() => this.setState({
            isVisibleDialog: show
        }));
    };

    handleSaveButton = (product: ProductModel) => {
        this.setState({
            isLoading: true
        });

        if (!product.productId) {
            this.productsService.addProduct(product).then(
                (data: any) => {
                    this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
                    this.setState({
                        isLoading: false
                    });
                    this.handleCloseAddEditProductModal();
                })
                .catch(error => {
                    this.snackbar.show({ severity: 'error', summary: error.message });
                    this.setState({
                        isLoading: false,
                    });
                })
        } else {
            this.productsService.editProduct(product).then(
                (data: any) => {
                    this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
                    this.setState({
                        isLoading: false
                    });
                    this.handleCloseAddEditProductModal();
                })
                .catch(error => {
                    this.snackbar.show({ severity: 'error', summary: error.message });
                    this.setState({
                        isLoading: false
                    });
                })
        }
    };

    handleCloseAddEditProductModal = () => {
        this.showAddEditDialog(false);
        this.setCurrentProduct(new ProductModel());
        this.getAllProducts(this.state.from, this.state.numberOfRows);
    }

    handleCancelButton = () => {
        this.showAddEditDialog(false);
    }

    setCurrentProduct(product: ProductModel) {
        this.setState({ currentProduct: { ...product } });
    }

    handleOnPageClick = (e) => {
        const startIndex = e.first;

        this.setState({
            numberOfRows: e.rows
        }, () => this.getAllProducts(startIndex, this.state.numberOfRows));
    }

    handleDeleteClick = (id, e) => {
        e.stopPropagation();
        this.getProduct(id);
        this.setState({
            isVisibleConfirmDialog: true
        });
    };

    getProduct = (id) => {
        this.setState({
            isLoading: true
        });

        this.productsService.getProduct(id)
            .then(
                (data: ProductModel) => {
                    this.setCurrentProduct(data);
                    this.setState({
                        isLoading: false
                    });
                })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleAddAndEditClick = (id) => {
        if (!id) {
            let newProduct = new ProductModel();
            if (this.state.selectedCategoryId)
                newProduct.categoryId = +this.state.selectedCategoryId;

            this.setCurrentProduct(newProduct);
            this.showAddEditDialog(true);
        } else {
            this.productsService.getProduct(id)
                .then(
                    (data: ProductModel) => {
                        this.setCurrentProduct(data);
                        this.showAddEditDialog(true);
                        this.setState({
                            isLoading: false
                        });
                    })
                .catch(error => {
                    this.snackbar.show({ severity: 'error', summary: error.message });
                    this.setState({
                        isLoading: false
                    });
                });
        }
    }

    handleFilters = (settings) => {
        this.setState({
            isLoading: true
        });

        this.productsService.getAllProducts(initFrom, numberOfRows, settings).then(
            (data: any) => {
                this.setState({
                    isLoading: false,
                    from: initFrom,
                    products: data.products,
                    productsSettings: settings,
                    totalRecordsCount: data.totalRecordsCount
                });
            })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleSearchButtonClick = (uSettings: ProductFilterSettingsModel) => {
        let settings: ProductFilterSettingsModel = JSON.parse(JSON.stringify(this.state.productsSettings));
        settings = uSettings;

        this.handleFilters(settings);
    }

    handleCategoryTreeClick = (categoryId, categoryFilterLabel) => {
        const productSettings: ProductFilterSettingsModel = { ...this.state.productsSettings };
        productSettings.categoryId = categoryId;

        this.setState({
            selectedCategoryId: categoryId,
            currentCategoryLabel: categoryFilterLabel
        });

        this.handleFilters(productSettings);
    }

    deleteProduct = (id) => {
        this.setState({
            isVisibleConfirmDialog: false,
            isLoading: true
        });

        this.productsService.deleteProduct(id)
            .then(
                data => {
                    this.snackbar.show({ severity: 'success', summary: Translate('Deleted Successfully') });
                    this.getAllProducts(this.state.from, this.state.numberOfRows);
                    this.setState({
                        isLoading: false,
                        currentProduct: new ProductModel()
                    });
                })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    generateCategoryLabel = () => {
        let label = this.state.selectedCategoryId ? this.state.currentCategoryLabel : Translate("All");
        let result = `${Translate("Category")}: <strong>${label}</strong>`;

        return result;
    }

    public render() {
        const { isLoading, isVisibleDialogWrap, products, numberOfRows } = this.state;

        let categoryLabelElement = this.generateCategoryLabel();
        return (
            <div style={{ marginBottom: 50 }}>
                <h1>{Translate("Articles")}</h1>

                {isLoading ? <Spinner /> : null}
                <Snackbar ref={(el) => this.snackbar = el} />

                {isVisibleDialogWrap ? (
                    <ProductAddEditDialog
                        closeAddEditProductModal={this.handleCloseAddEditProductModal}
                        cancelClick={this.handleCancelButton}
                        saveClick={this.handleSaveButton}
                        currentProduct={this.state.currentProduct}
                        isVisible={this.state.isVisibleDialog}
                    />
                ) : null}

                <ProductFilter
                    productSettings={this.state.productsSettings}
                    onSearchClick={this.handleSearchButtonClick}
                    totalRecordsCount={this.state.totalRecordsCount}
                />

                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                    <div style={{ width: '20%', marginRight: 10 }}>
                        <CategoryTreeFilter
                            currentCategoryId={this.state.selectedCategoryId}
                            onCategoryClick={this.handleCategoryTreeClick}
                        />
                    </div>
                    <div style={{ width: '80%', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ padding: 10, marginBottom: 10, backgroundColor: "#f5f5f5", display: 'flex', alignItems: "center" }} >
                            <div>
                                <span dangerouslySetInnerHTML={{ __html: categoryLabelElement }}></span>
                            </div>
                            {this.state.selectedCategoryId
                                ? <div style={{ marginLeft: 10, cursor: "pointer" }}
                                    onClick={(e) => this.handleCategoryTreeClick(0, '')}
                                >
                                    <FontAwesomeIcon
                                        icon={faTimesCircle}
                                        style={{ color: "rgb(220, 0, 78)", fontSize: '1.3em' }}
                                    />
                                </div>
                                : null}
                        </div>
                        {this.state.totalRecordsCount
                            ? <ProductList
                                products={products}
                                rows={numberOfRows}
                                totalRecords={this.state.totalRecordsCount}
                                onPageClick={this.handleOnPageClick}
                                first={this.state.from}
                                loading={Spinner}
                                editClick={this.handleAddAndEditClick}
                                deleteClick={this.handleDeleteClick}
                            />
                            : <div style={{ marginLeft: 10 }}>
                                {Translate("NoRecordsFound")}
                            </div>
                        }

                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                            <Button color="primary" variant="contained" style={{ marginRight: 10 }} onClick={() => this.handleAddAndEditClick(null)}>
                                {Translate("Add")}
                            </Button>
                        </div>
                    </div>
                </div>

                <ConfirmDialog
                    headerTitle={Translate("Confirm Dialog")}
                    isVisible={this.state.isVisibleConfirmDialog}
                    yesClick={() => { this.deleteProduct(this.state.currentProduct.productId) }}
                    noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
                    {Translate("Are you sure that you want to delete")} "{this.state.currentProduct.article}"?
               </ConfirmDialog>

            </div>
        )
    }
}

export default ProductsContainer